import { CmdType, HTTPRequest, HTTPRequestBody } from 'shared/constants/common'
import { axiosPostData } from 'shared/utils'
import { formatHistories } from 'shared/utils/format'

// 특허증, 뉴스 리스트 호출
export const getPatentAndNewsList = async (cmdType, type, offset, length) => {
  /**
   * 특허
   * 1 : 전체가져오기 | 0 : Length Offset 기준으로 쿼리 실행
   * 뉴스
   * 1 : 전체가져오기 | 0 : Length Offset 기준으로 쿼리 실행 | 2 : 최근뉴스 1개 | 3 : 메인뉴스 1개
   */
  const body = new HTTPRequestBody()
  body.type = type
  body.offset = offset
  body.length = length

  const httpRequest = new HTTPRequest(CmdType[cmdType], body)

  return await axiosPostData(httpRequest)
}

// // History 리스트 호출
export const getHistoryList = async (cmdType, page, step = 3) => {
  const body = new HTTPRequestBody()
  body.page = page
  body.step = step

  const httpRequest = new HTTPRequest(CmdType[cmdType], body)

  const result = await axiosPostData(httpRequest)
  return formatHistories(result)
}

// History, Patent, NEWS toall 호출
export const getTotalNum = async (cmdType) => {
  const body = new HTTPRequestBody()

  const httpRequest = new HTTPRequest(CmdType[cmdType], body)

  return await axiosPostData(httpRequest)
}

// Csr 키워드 리스트 호출
export const getCsrKeywords = async (type) => {
  /**
   * 0: 기부 | 1: 캠페인
   */
  const body = new HTTPRequestBody()
  body.Type = type

  const httpRequest = new HTTPRequest(CmdType['CSR_KEYWORDS'], body)

  return await axiosPostData(httpRequest)
}

// Csr 기부 리스트 호출
export const getCsrDonation = async () => {
  const body = new HTTPRequestBody()
  body.Offset = 0
  body.Length = 100

  const httpRequest = new HTTPRequest(CmdType['CSR_DONATION'], body)

  return await axiosPostData(httpRequest)
}

// Csr 기부 인증 리스트 호출
export const getCsrCert = async () => {
  const body = new HTTPRequestBody()
  body.Type = 2

  const httpRequest = new HTTPRequest(CmdType['IMAGE'], body)

  return await axiosPostData(httpRequest)
}

// Csr 캠페인 리스트 호출
export const getCsrCampaign = async () => {
  const body = new HTTPRequestBody()
  body.Offset = 0
  body.Length = 100

  const httpRequest = new HTTPRequest(CmdType['CSR_CAMPAIGN'], body)

  return await axiosPostData(httpRequest)
}
